var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('MainContainerTopImage'),_c('MainContainerFirstContents'),_c('MainContainerSlideShow'),_c('MainContainerSecondContents'),_c('Main-container-third-contents')],1)}
var staticRenderFns = []

export { render, staticRenderFns }